<template lang="pug">
extends ./BaseMessage/BaseMessage.pug
block child
  .message-replies-wrapper(:class="{'message-webchat': inWebchat}"
                            :style="{textAlign: textAlign}")
    .message-replies-text(v-if="content") {{content}}
    aiq-button(v-for="(item, index) in attachments",
              :key="index",
              :disabled="isDisabled",
              type="primary"
              :plain="!selectionMap[index]"
              size="small",
              :class="{ 'is-selected': selectionMap[index] }",
              @click="selectItem(item.reply.content)") {{ item.reply.content }}
</template>

<script>
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { getIndicesForMatchingReplies } from '../../../lib/replies';
import BaseMessage from './BaseMessage/BaseMessage.vue';

export default {
  extends: BaseMessage,
  name: 'aiq-replies',
  props: {
    message: {
      type: Object,
      required: true,
      default: () => ({
        payload: {
          message_type: 'replies',
          replies: { content: '', attachments: [] },
        },
        disabled: false,
        replyitem: null,
      }),
    },
    inWebchat: Boolean,
  },
  computed: {
    content() {
      return get(this.message, 'payload.replies.content', '');
    },
    isDisabled() {
      return (
        get(this.message, 'disabled', false) || !isEmpty(this.message.replyitem)
      );
    },
  },
  data() {
    return {
      selectionMap: {},
    };
  },
  watch: {
    message: {
      handler() {
        this.selectionMap = {};
        this.markItemReplied();
      },
      deep: true,
    },
  },
  mounted() {
    this.markItemReplied();
  },
  methods: {
    markItemReplied() {
      const replyitem = get(this, 'message.replyitem');
      if (replyitem) {
        const indices = getIndicesForMatchingReplies(
          replyitem,
          this.attachments,
        );
        if (indices && indices.length > 0) {
          indices.forEach(i => {
            // get indices returns -1 if no match, make sure
            // we don't acccidentally pass back an invalid index.
            if (i >= 0) {
              this.selectionMap[i] = true;
            }
          });
        }
      }
    },
    itemFinder(item) {
      return d => d.reply.content === item;
    },
    prepareReply(item) {
      if (get(item.reply.postback.reply_to)) {
        item.reply.postback.reply_to = this.message.replies.id;
      }
      return item;
    },
    selectItem(item) {
      if (!this.replyitem) {
        const selectedItem = this.attachments.find(this.itemFinder(item));
        const reply = this.prepareReply(selectedItem);
        this.$emit('reply', reply);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
